module.exports = __webpack_public_path__ + "img/TV_clean_box15.23007ec1.jpg";